import React, { useState } from 'react';
import { SeasonPassFieldLabel } from '../../../SeasonPass/SeasonPassFieldLabel';
import swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';

const MySwal = withReactContent(swal);

export const AddMapModal = ({ addMap }) => {
  const [mapData, setMapData] = useState({
    name: '',
    publicChartKey: '',
    hideChartKey: '',
  });

  const handleChangeFormData = (key, value) => {
    setMapData(prev => ({
      ...prev,
      [key]: value,
    }))
  };

  return (
    <form onSubmit={e => e.preventDefault()}>
      <SeasonPassFieldLabel
        label="Name"
      >
        <input
          name="name"
          placeholder="Enter map name"
          onChange={({ target }) => handleChangeFormData(target.name, target.value)}
          type="text"
          value={mapData.name}
        />
      </SeasonPassFieldLabel>

      <SeasonPassFieldLabel
        label="Public chart key"
      >
        <input
          name="publicChartKey"
          placeholder="Enter public chart key"
          onChange={({ target }) => handleChangeFormData(target.name, target.value)}
          type="text"
          value={mapData.publicChartKey}
        />
      </SeasonPassFieldLabel>

      <SeasonPassFieldLabel
        label="Hidden chart key"
      >
        <input
          name="hideChartKey"
          placeholder="Enter hidden chart key"
          onChange={({ target }) => handleChangeFormData(target.name, target.value)}
          type="text"
          value={mapData.hideChartKey}
        />
      </SeasonPassFieldLabel>

      <div className='swal2-actions'>
        <button
          className='swal2-cancel swal2-styled'
          onClick={() => MySwal.close()}
        >
          Cancel
        </button>
        <button
          type="button"
          className="swal2-confirm swal2-styled"
          onClick={() => addMap(mapData)}
          disabled={!mapData.name || !mapData.hideChartKey || !mapData.publicChartKey}
        >
          <span>Add map</span>
        </button>
      </div>

      
    </form>
  )
}
